module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADhSURBVHgB7ZPhDYIwEIWvDQM4AiOwATqBOgFxAuMEtgkD6ATGCXQDcANGYAQWgPqeUWP9Y6m/TLzkcuWAjzvynirLsuj7ficiEwmP1jm3NMY0j0YCiEHziPM5lKKU2qIY5OIJQqaEgF4HcgTPTlHy114ikYGpMmttxTM2WmmJjw6AC4AdsooGAdJiRTMMwx6X6TcTefEH/SKIym611uu77IMCAiyQtQeCsGaoB9ygdzJkR/gHUAMhWg+ESfgSYULvUPZUrIwMz7SA0Df5mDXxW+a0y7v7Oe6JJgzk3D6O3FwBmehczgQrVDUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/layer.png
// module id = JyTi
// module chunks = 46